import { RouteObject } from "react-router-dom";

import { AuthorizedRoute } from "src/authentication/AuthorizedRoute.tsx";
import { Scope, ScopeResource } from "src/authentication/PermissionsProvider.tsx";
import DynamicViewSchemaProvider from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.tsx";
import { useT } from "src/internationalization";
import { CustomerDetailsPage } from "src/pages/CustomerDetails/CustomerDetailsPage";
import CustomersPage from "src/pages/Customers/CustomersPage.tsx";

import ErrorBoundary from "../components/Errors/ErrorBoundary";

export const useCustomersRoutes = (): RouteObject[] => {
  const t = useT();

  return [
    {
      path: "customers",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.CUSTOMER, scopes: [Scope.VIEW] }]}
          pageTitle={t("page.customers.title")}
        >
          <DynamicViewSchemaProvider>
            <CustomersPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
    {
      path: "customer/:id",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.CUSTOMER, scopes: [Scope.VIEW] }]}
          pageTitle={t("page.customers.title")}
        >
          <DynamicViewSchemaProvider>
            <CustomerDetailsPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
    {
      path: "customer/:id/:code",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.CUSTOMER, scopes: [Scope.VIEW] }]}
          pageTitle={t("page.customers.title")}
        >
          <DynamicViewSchemaProvider>
            <CustomerDetailsPage />
          </DynamicViewSchemaProvider>
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
  ];
};
